module.exports = __webpack_public_path__ + "img/ic_32_workout_low-active.d4b400fb.svg";